import { connect } from 'react-redux'

import { getUserFirstName, getUserEmail } from 'selectors/user'
import { getUserOrderById } from 'utils/user'

import { WelcomeFirstBoxOrderWrapper } from './WelcomeFirstBoxOrderWrapper'

function mapStateToProps(state: any) {
  const nameFirst = getUserFirstName(state)
  const userEmail = getUserEmail(state)
  const orderId = state.basket.get('orderId')
  const order = getUserOrderById(orderId, state.user.get('orders'))

  return {
    nameFirst,
    userEmail,
    periodId: String(order.getIn(['period', 'id'])),
  }
}

const WelcomeFirstBoxOrderWrapperContainer = connect(mapStateToProps)(WelcomeFirstBoxOrderWrapper)

export { WelcomeFirstBoxOrderWrapperContainer }
